/**
 * @generated SignedSource<<34cdf1322dfc8a589cd7c8577e8aec28>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "resellerPId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "resellerPId",
    "variableName": "resellerPId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resellerPId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resellerAccountId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paySubscriptionFees",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "basedOnPartnersSalesFor",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "payOutCommissionsEvery",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionsActiveAtLeast",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stopCommissionsAfter",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoPayout",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerAppId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cpId",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "REVENUE_MIN_ASC"
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resellerPlId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenuePeriod",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueMin",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentivePerc",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerProgramEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ResellerProgramT",
        "kind": "LinkedField",
        "name": "resellerProgramTByResellerPId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByResellerAccountId",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CpT",
            "kind": "LinkedField",
            "name": "cpTByCpId",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v6/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "ResellerProgramLineTsConnection",
            "kind": "LinkedField",
            "name": "resellerProgramLineTsByResellerPId",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ResellerProgramLineT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "resellerProgramLineTsByResellerPId(orderBy:\"REVENUE_MIN_ASC\")"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResellerProgramEditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ResellerProgramT",
        "kind": "LinkedField",
        "name": "resellerProgramTByResellerPId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountTByResellerAccountId",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CpT",
            "kind": "LinkedField",
            "name": "cpTByCpId",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v6/*: any*/),
              (v14/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "ResellerProgramLineTsConnection",
            "kind": "LinkedField",
            "name": "resellerProgramLineTsByResellerPId",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ResellerProgramLineT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "resellerProgramLineTsByResellerPId(orderBy:\"REVENUE_MIN_ASC\")"
          },
          (v24/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d557e83458b0354c194678fe6ece15c4",
    "id": null,
    "metadata": {},
    "name": "ResellerProgramEditQuery",
    "operationKind": "query",
    "text": "query ResellerProgramEditQuery(\n  $resellerPId: UUID!\n) {\n  resellerProgramTByResellerPId(resellerPId: $resellerPId) {\n    resellerPId\n    resellerAccountId\n    accountTByResellerAccountId {\n      accountName\n      nodeId\n    }\n    programType\n    programName\n    description\n    notes\n    paySubscriptionFees\n    basedOnPartnersSalesFor\n    payOutCommissionsEvery\n    subscriptionsActiveAtLeast\n    stopCommissionsAfter\n    autoPayout\n    active\n    customerAppId\n    cpId\n    cpTByCpId {\n      cpId\n      programName\n      autoPayout\n      nodeId\n    }\n    resellerProgramLineTsByResellerPId(orderBy: REVENUE_MIN_ASC) {\n      totalCount\n      nodes {\n        resellerPlId\n        revenuePeriod\n        revenueMin\n        incentivePerc\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "9f7b5f7b2ad83e0a662276a659f8dfe1";

module.exports = node;
